<template>
    <line-chart
        :data="chartData"
        :library="chartOptions"
        :height="300"
    />
</template>

<script>
import { defineComponent } from 'vue'
import { LineChart } from 'vue-chartkick'

export default defineComponent({
    name: 'CommissionChangeTimeline',
    components: { LineChart },
    props: {
        timelineData: {
            type: Array,
            required: true
        }
    },
    computed: {
        chartData() {
            // Group by date and get totals, plus separate rugs
            const dates = [...new Set(this.timelineData.map(d => d.date))].sort();

            const totalChanges = [];
            const rugChanges = [];
            const fromZeroChanges = [];

            dates.forEach(date => {
                const dayData = this.timelineData.filter(d => d.date === date);
                const total = dayData.reduce((sum, item) => sum + parseInt(item.count || 0), 0);
                const rugs = dayData.find(d => d.change_type === 'rug')?.count || 0;
                const fromZero = dayData.find(d => d.change_type === 'from_zero')?.count || 0;

                totalChanges.push([date, total]);
                if (parseInt(rugs) > 0) {
                    rugChanges.push([date, parseInt(rugs)]);
                }
                if (parseInt(fromZero) > 0) {
                    fromZeroChanges.push([date, parseInt(fromZero)]);
                }
            });

            return [
                { name: 'Total Changes', data: totalChanges },
                { name: 'Rugs (to 100%)', data: rugChanges },
                { name: 'Leaving 0%', data: fromZeroChanges }
            ];
        },
        chartOptions() {
            return {
                colors: ['#007bff', '#dc3545', '#ffc107'],
                scales: {
                    x: {
                        type: 'time',
                        time: {
                            unit: 'day',
                            displayFormats: {
                                day: 'MMM d'
                            }
                        }
                    },
                    y: {
                        beginAtZero: true,
                        title: {
                            display: true,
                            text: 'Number of Changes'
                        }
                    }
                },
                plugins: {
                    legend: {
                        display: true,
                        position: 'top'
                    }
                }
            };
        }
    }
})
</script>
